
import { ref } from "vue";
import axios from "axios";

export function useSearch() {
    const searchQuery = ref("");
    const autoCompleteResults = ref([]);
    const searchResults = ref([]);
    const isLoading = ref(false);

    const getAuthors = async () => {
        const endpoint = `${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/open-search-service/get-authors`;

        try {
            const response = await axios.get(endpoint);
            return response.data
        } catch (error) {
            console.error("Error getting authors:", error);
        }
    }

    const getSearchResults = async (param, filters) => {
        const query = typeof param === 'string' ? param : param?.query;



        if (query.trim() === "") {
            autoCompleteResults.value = [];
            searchResults.value = [];
            isLoading.value = false;
            return;
        }

        const endpoint = `${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/open-search-service/search-query`;
        const filterParams = new URLSearchParams(filters).toString();
        const urlWithParams = `${endpoint}?q=${encodeURIComponent(query)}&index=${encodeURIComponent('published-slides')}&${filterParams}`;


        isLoading.value = true;
        try {
            const response = await axios.get(urlWithParams);
            autoCompleteResults.value = response.data.map(entry => ({
                label: entry.name,
                value: entry.id,
                valueModelName: entry.valueModelName,
                authorName: entry.author.name,
                vmId: entry.valueModelId,
                ...entry
            }));


            searchResults.value = response.data.map(entry => ({
                id: entry.id,
                name: entry.name,
                authorName: entry.author.name,
                created: entry.created,
                updated: entry.updated,
                valueModelName: entry.valueModelName
            }));


            isLoading.value = false
        } catch (error) {
            console.error("Error getting search results:", error);
        }
    };


    return {
        searchQuery,
        autoCompleteResults,
        searchResults,
        getSearchResults,
        isLoading,
        getAuthors
    };
}
